interface MarkProps {
  className?: string;
}

export function ThermalMark({ className }: MarkProps) {
  return (
    <svg viewBox="0 0 100 100" className={className} fill="none">
      <ellipse cx="50" cy="50" rx="40" ry="18" stroke="currentColor" strokeWidth="2" transform="rotate(-20 50 50)" />
      <ellipse cx="50" cy="50" rx="25" ry="10" stroke="currentColor" strokeWidth="2" transform="rotate(-20 50 50)" />
      <ellipse cx="50" cy="50" rx="10" ry="4" stroke="currentColor" strokeWidth="2" transform="rotate(-20 50 50)" />
      <line x1="50" y1="5" x2="50" y2="95" stroke="currentColor" strokeWidth="2" strokeDasharray="6 6" />
    </svg>
  );
}
